import React from 'react'
import { Alert, Box } from '@deere/fuel-react'
import { useTranslation } from 'react-i18next'
import { SCBM_STATES_CAMPAIGN } from '../utils/surveyLiterals'

export default function CampaignClosedAlert({ campaign }) {
    const { t } = useTranslation();
    if (!campaign || campaign.status !== SCBM_STATES_CAMPAIGN.CLOSED) {
        return null;
    }
    return (
        <Box pt={2} pb={2}>
            <Alert variant="info" title={t('campaign_closed_title')}>
                {t('campaign_closed_message')}
            </Alert>
        </Box>
    );
}
